import { createSlice } from "@reduxjs/toolkit";
import { getDashboardDataThunk, addPatientThunk } from "../thunk";
import { logout } from "../slices";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    clearDashboard: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardDataThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardDataThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.data = action.payload.data;
          state.error = null;
        } else {
          state.error = action.payload?.message || "Failed to fetch";
        }
      })
      .addCase(getDashboardDataThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch dashboard data";
      })
      .addCase(addPatientThunk.fulfilled, (state) => {
        state.data = null;
      })
      .addCase(logout, () => initialState);
  },
});

export const { clearDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
